export const roundFloat = (value: number, shouldRound: boolean = true): number => {
    if (Math.ceil(value) === value) return value;

    if (!shouldRound) {
        return +value.toFixed(2);
    }

    return Math.round(value);
};
